import {App as RefraFeatureApp} from '@refra/App'
import {Routes, Route, Navigate} from 'react-router'

import {
  RefraPlannerPlantPage,
  RefraPlannerTabRedirect,
  PageForbidden,
  PageNotFound,
  PlantSelectorRedirect,
  RefraCatalogBridge
} from './pages'
import {ROUTES} from './routes'

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Root path should redirect to the plant select page */}
      <Route index element={<PlantSelectorRedirect />} />

      <Route path={ROUTES.PLANT_SELECTOR.path}>
        {/* /plants path should redirect to the plant select page */}
        <Route index element={<PlantSelectorRedirect />} />
        <Route path={ROUTES.PLANT_SELECTOR.PLANT.path} element={<RefraPlannerPlantPage />}>
          {/* /:plantCode path should redirect to the first available refra planner tab */}
          <Route index element={<RefraPlannerTabRedirect />} />
          <Route path="*" element={<RefraFeatureApp catalogElement={<RefraCatalogBridge />} />} />
        </Route>
      </Route>

      <Route path={ROUTES.NOT_AUTHORIZED.path} element={<PageForbidden />} />
      <Route path={ROUTES.NOT_FOUND.path} element={<PageNotFound />} />

      {/* No matching route should redirect to 404 page */}
      <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND.path} replace />} />
    </Routes>
  )
}
